import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import BackButton from 'components/BackButton';
import KeyboardSmall from 'components/keyboard-small';
import FormHeader from 'components/Form/Header';
import ActionsSection from 'components/Form/ActionsSection';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import { profileActions } from 'store/profile';
import { StyledBlock } from './StyledComponents';

const SECTION_NAME = 'PIN_CREATE_NEW';
const MAX_PIN_LENGTH = 4;

const KEYBOARD_CONFIG = {
  leaveFor: {
    left: `@${SECTION_NAME}`,
    right: '',
    up: '',
    down: '',
  },
};

const PinCreateNewPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [pin, setPin] = useState('');
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(true);
  const [isPinValid, setIsPinValid] = useState(true);

  const isPinComplete = () => pin.length === MAX_PIN_LENGTH;

  const onSubmit = () => {
    dispatch(profileActions.setPin(pin));
    history.goBack();
  };

  const showKeyboard = () => {
    setIsKeyboardVisible(true);
    setIsPinValid(true);
    SpatialNavigationWrapper.focus('@KEYBOARD_NUM');
  };

  const hideKeyboard = () => setIsKeyboardVisible(false);

  const onKeyboardInput = (value) => {
    if (value === 'remove') {
      setPin((v) => v.slice(0, -1));
    } else if (value === 'close') {
      setIsKeyboardVisible(false);
      setIsPinValid(isPinComplete());

      SpatialNavigationWrapper.focus(`@${SECTION_NAME}`);
    } else if (!isPinComplete()) {
      setPin((v) => v + value);
    }
  };

  return (
    <>
      <BackButton onEnter={history.goBack} />
      <div>
        <FormHeader title="Create new PIN" description="Please enter a new PIN" />
        <StyledBlock>
          <ActionsSection id={SECTION_NAME} sectionName={SECTION_NAME} defaultSection>
            <ActionsSection.PinInput
              value={pin}
              isValid={isPinValid}
              invalidMessage={'Invalid Pin'}
              cursor={isKeyboardVisible}
              onEnter={showKeyboard}
            />
            <ActionsSection.Button label={'Save'} onEnter={onSubmit} onFocus={hideKeyboard} />
          </ActionsSection>
          {isKeyboardVisible && (
            <KeyboardSmall
              className="keyboard-small__phone"
              onEnter={onKeyboardInput}
              config={KEYBOARD_CONFIG}
            />
          )}
        </StyledBlock>
      </div>
    </>
  );
};

export default PinCreateNewPage;
